import { HelperResult } from '@openclassrooms/sdk-web';
import { TrainingAccommodation } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserTrainingAccommodations, useUpdate: useUpdateUserTrainingAccommodations } =
  getCRUDHooks({
    entityName: 'userTrainingAccommodations',
    get: ({ userId }): HelperResult<TrainingAccommodation[]> =>
      clientApi.getOCClient().helpers.user.users.id(userId).trainingAccommodations.find(),
    update: (values, { userId, context }) =>
      clientApi
        .getOCClient()
        .helpers.user.users.id(userId)
        .trainingAccommodations.update('', values, false)
        .setHeader('X-Request-Context', context)
        .execute(),
  });

const { useGet: useTrainingAccommodations } = getCRUDHooks({
  entityName: 'trainingAccommodations',
  get: ({ userCountry }): HelperResult<TrainingAccommodation[]> =>
    clientApi
      .getOCClient()
      .helpers.trainingAccommodations.trainingAccommodations.find({ countries: userCountry }),
});

export {
  useUserTrainingAccommodations,
  useUpdateUserTrainingAccommodations,
  useTrainingAccommodations,
};
